import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { UserActionType, UserContext } from '../state/user-state'
import { getForwardingPath, setFakeAuthToken } from '../services/auth-utils'
import { MenuLinks } from '../../constants'

export default function FakeAuthTokenCatcher() {
  const location = useLocation()
  const navigate = useNavigate()
  const [isLoaded, setIsLoaded] = useState(false)
  const [redirectLocation, setRedirectLocation] = useState('/dashboard')
  const token = location.search.split('=')[1]

  const { dispatch } = useContext(UserContext)

  useEffect(() => {
    if (token) {
      dispatch({ type: UserActionType.SET_TOKEN, payload: { token } })
      const location = getForwardingPath()
      if (location) setRedirectLocation(location === '/' ? MenuLinks.DASHBOARD : location)

      setIsLoaded(true)
      setFakeAuthToken(token)
    }
  }, [token, dispatch])

  useEffect(() => {
    if (isLoaded) navigate(redirectLocation)
  }, [isLoaded, navigate, redirectLocation])

  return null
}
